





















import Vue from "vue";
import { Component } from "vue-property-decorator";
import Board from "./Board.vue";
import CardModal from "./CardModal.vue";
import CommentModal from "./CommentModal.vue";
import { Action, State } from "vuex-class";
import { board, project } from "../board";

@Component({
  components: {
    Board,
    CardModal,
    CommentModal,
  },
})
export default class ProjectPage extends Vue {
  private newBoardName = "";
  @Action private createBoard;
  @State boards: board[];
  @State("selectedProject") storeSelectedProject: project;

  public addNewBoard() {
    if (this.newBoardName !== "") {
      this.createBoard({
        name: this.newBoardName,
        project: this.storeSelectedProject._id,
      });
      this.newBoardName = "";
    }
  }

  get selectedProject() {
    return this.storeSelectedProject;
  }
}
